<span [ngbTooltip]="tooltip">
  <button
    class="btn"
    [ngClass]="'btn-' + bsClass"
    [disabled]="disabled"
    [type]="buttonType"
    [class.btn-labeled]="labeled"
    (click)="handleClick.emit($event)"
  >
    <span class="btn-label" *ngIf="labeled">
      <i class="fas fa-check" *ngIf="!showLoader"></i>
      <app-loading-spinner *ngIf="showLoader" size="sm"></app-loading-spinner>
    </span>

    <ng-content></ng-content>
  </button>
</span>
